import { render, staticRenderFns } from "./huifang.vue?vue&type=template&id=bf9a45c6&scoped=true"
import script from "./huifang.vue?vue&type=script&lang=js"
export * from "./huifang.vue?vue&type=script&lang=js"
import style0 from "./huifang.vue?vue&type=style&index=0&id=bf9a45c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9a45c6",
  null
  
)

export default component.exports